// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 豆包视频生成节点样式 */

/* 节点容器 */
.DoubaoVideoNode-container {
  position: relative;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  min-width: 320px;
}

.DoubaoVideoNode-container:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-color: #8b5cf6;
}

/* 标题 */
.DoubaoVideoNode-title {
  padding: 12px 16px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  border-radius: 10px 10px 0 0;
  text-align: center;
  user-select: none;
}

/* 内容包装器 */
.DoubaoVideoNode-wrapper {
  padding: 16px;
  width: 320px;
}

/* Handle 样式 */
.DoubaoVideoNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid #8b5cf6;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.DoubaoVideoNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

.DoubaoVideoNode-handle-prompt {
  border-color: #667eea;
  background: #667eea;
}

.DoubaoVideoNode-handle-image {
  border-color: #48bb78;
  background: #48bb78;
}

.DoubaoVideoNode-handle-output {
  border-color: #8b5cf6;
  background: #8b5cf6;
}

/* Handle 标签 */
.DoubaoVideoNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

/* 可点击的 Handle 标签 */
.DoubaoVideoNode-handle-label-clickable {
  pointer-events: auto;
  cursor: pointer;
  user-select: none;
}

.DoubaoVideoNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.45);
  background: linear-gradient(135deg, #a78bfa 0%, #9333ea 100%);
}

.DoubaoVideoNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

.DoubaoVideoNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.DoubaoVideoNode-handle-label-clickable:hover::after {
  opacity: 1;
}

.DoubaoVideoNode-handle:hover .DoubaoVideoNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);
}

.DoubaoVideoNode-handle:hover .DoubaoVideoNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #8b5cf6;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(139, 92, 246, 0.2));
}

.DoubaoVideoNode-handle-prompt .DoubaoVideoNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.DoubaoVideoNode-handle-prompt:hover .DoubaoVideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.DoubaoVideoNode-handle-prompt:hover .DoubaoVideoNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

.DoubaoVideoNode-handle-image .DoubaoVideoNode-handle-label {
  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
}

.DoubaoVideoNode-handle-image:hover .DoubaoVideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

.DoubaoVideoNode-handle-image:hover .DoubaoVideoNode-handle-label::before {
  border-left-color: #48bb78;
  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .DoubaoVideoNode-handle .DoubaoVideoNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);
}

.react-flow__node.selected .DoubaoVideoNode-handle-prompt .DoubaoVideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.react-flow__node.selected .DoubaoVideoNode-handle-image .DoubaoVideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

/* 标签出现动画 */
@keyframes DoubaoVideoNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.DoubaoVideoNode-handle:hover .DoubaoVideoNode-handle-label,
.react-flow__node.selected .DoubaoVideoNode-handle .DoubaoVideoNode-handle-label {
  animation: DoubaoVideoNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 字段容器 */
.DoubaoVideoNode-field {
  margin-bottom: 16px;
}

/* 标签 */
.DoubaoVideoNode-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 13px;
  color: #374151;
}

/* 按钮组 */
.DoubaoVideoNode-button-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

/* 视频比例按钮网格 - 4列布局 */
.DoubaoVideoNode-aspect-ratio-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

/* 视频比例按钮 - 字体稍小以适应较长的文本 */
.DoubaoVideoNode-aspect-ratio-button {
  font-size: 12px;
  padding: 8px 6px;
  white-space: nowrap;
}

/* 单个按钮 */
.DoubaoVideoNode-button {
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  background-color: #ffffff;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.DoubaoVideoNode-button:hover:not(:disabled) {
  border-color: #8b5cf6;
  color: #8b5cf6;
  background-color: #f5f3ff;
}

.DoubaoVideoNode-button-active {
  border-color: #8b5cf6;
  background-color: #8b5cf6;
  color: #ffffff;
}

.DoubaoVideoNode-button-active:hover:not(:disabled) {
  background-color: #7c3aed;
  border-color: #7c3aed;
}

.DoubaoVideoNode-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.DoubaoVideoNode-button-disabled {
  background-color: #f3f4f6;
  color: #d1d5db;
  border-color: #e5e7eb;
  cursor: not-allowed;
}

/* 小提示 */
.DoubaoVideoNode-hint-small {
  margin-top: 6px;
  font-size: 11px;
  color: #f59e0b;
  line-height: 1.4;
}

/* 提示信息 */
.DoubaoVideoNode-hint {
  padding: 12px;
  background-color: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.6;
  color: #78350f;
  margin-bottom: 16px;
}

/* 参考图片网格展示 */
.DoubaoVideoNode-image-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-top: 8px;
}

.DoubaoVideoNode-image-thumb {
  position: relative;
  aspect-ratio: 1;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid #e5e7eb;
  transition: all 0.2s;
  background: #f9fafb;
}

.DoubaoVideoNode-image-thumb:hover {
  border-color: #8b5cf6;
  transform: scale(1.05);
  z-index: 10;
}

.DoubaoVideoNode-image-inactive {
  opacity: 0.4;
  filter: grayscale(0.5);
}

.DoubaoVideoNode-image-dragging {
  opacity: 0.5;
  transform: scale(0.95);
}

.DoubaoVideoNode-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.DoubaoVideoNode-thumb-index {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(139, 92, 246, 0.9);
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
}

.DoubaoVideoNode-thumb-role {
  position: absolute;
  bottom: 4px;
  left: 4px;
  background: rgba(16, 185, 129, 0.95);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

/* 图片占位符 */
.DoubaoVideoNode-image-placeholder {
  padding: 40px 20px;
  text-align: center;
  background-color: #f9fafb;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  color: #9ca3af;
  font-size: 13px;
}

/* 生成按钮 */
.DoubaoVideoNode-generate {
  width: 100%;
  padding: 12px 20px;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);
}

.DoubaoVideoNode-generate:hover:not(:disabled) {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
  transform: translateY(-1px);
}

.DoubaoVideoNode-generate:active:not(:disabled) {
  transform: translateY(0);
}

.DoubaoVideoNode-generate-disabled {
  background: #d1d5db;
  cursor: not-allowed;
  box-shadow: none;
}

/* 错误提示 */
.DoubaoVideoNode-error {
  margin-top: 12px;
  padding: 12px;
  background-color: #fee2e2;
  border: 1px solid #ef4444;
  border-radius: 8px;
  color: #991b1b;
  font-size: 13px;
  line-height: 1.5;
}

/* 复制按钮样式 */
.DoubaoVideoNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.DoubaoVideoNode-container:hover .DoubaoVideoNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.DoubaoVideoNode-duplicate-button:hover {
  background: #f0f0f0;
  border-color: #3b82f6;
  color: #3b82f6;
  transform: scale(1.05);
}

.DoubaoVideoNode-duplicate-button:active {
  transform: scale(0.95);
}

.react-flow__node.selected .DoubaoVideoNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/DoubaoVideoNode.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf,SAAS;AACT;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,OAAO;AACP;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,YAAY;AACd;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wDAAwD;EACxD,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,wEAAwE;AAC1E;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA,OAAO;AACP;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,QAAQ;AACR;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* 豆包视频生成节点样式 */\n\n/* 节点容器 */\n.DoubaoVideoNode-container {\n  position: relative;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  min-width: 320px;\n}\n\n.DoubaoVideoNode-container:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border-color: #8b5cf6;\n}\n\n/* 标题 */\n.DoubaoVideoNode-title {\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 10px 10px 0 0;\n  text-align: center;\n  user-select: none;\n}\n\n/* 内容包装器 */\n.DoubaoVideoNode-wrapper {\n  padding: 16px;\n  width: 320px;\n}\n\n/* Handle 样式 */\n.DoubaoVideoNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #8b5cf6;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.DoubaoVideoNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n.DoubaoVideoNode-handle-prompt {\n  border-color: #667eea;\n  background: #667eea;\n}\n\n.DoubaoVideoNode-handle-image {\n  border-color: #48bb78;\n  background: #48bb78;\n}\n\n.DoubaoVideoNode-handle-output {\n  border-color: #8b5cf6;\n  background: #8b5cf6;\n}\n\n/* Handle 标签 */\n.DoubaoVideoNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n/* 可点击的 Handle 标签 */\n.DoubaoVideoNode-handle-label-clickable {\n  pointer-events: auto;\n  cursor: pointer;\n  user-select: none;\n}\n\n.DoubaoVideoNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.45);\n  background: linear-gradient(135deg, #a78bfa 0%, #9333ea 100%);\n}\n\n.DoubaoVideoNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n.DoubaoVideoNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.DoubaoVideoNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n.DoubaoVideoNode-handle:hover .DoubaoVideoNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);\n}\n\n.DoubaoVideoNode-handle:hover .DoubaoVideoNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #8b5cf6;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(139, 92, 246, 0.2));\n}\n\n.DoubaoVideoNode-handle-prompt .DoubaoVideoNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.DoubaoVideoNode-handle-prompt:hover .DoubaoVideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.DoubaoVideoNode-handle-prompt:hover .DoubaoVideoNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n.DoubaoVideoNode-handle-image .DoubaoVideoNode-handle-label {\n  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);\n}\n\n.DoubaoVideoNode-handle-image:hover .DoubaoVideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n.DoubaoVideoNode-handle-image:hover .DoubaoVideoNode-handle-label::before {\n  border-left-color: #48bb78;\n  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .DoubaoVideoNode-handle .DoubaoVideoNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);\n}\n\n.react-flow__node.selected .DoubaoVideoNode-handle-prompt .DoubaoVideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.react-flow__node.selected .DoubaoVideoNode-handle-image .DoubaoVideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes DoubaoVideoNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.DoubaoVideoNode-handle:hover .DoubaoVideoNode-handle-label,\n.react-flow__node.selected .DoubaoVideoNode-handle .DoubaoVideoNode-handle-label {\n  animation: DoubaoVideoNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 字段容器 */\n.DoubaoVideoNode-field {\n  margin-bottom: 16px;\n}\n\n/* 标签 */\n.DoubaoVideoNode-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  font-size: 13px;\n  color: #374151;\n}\n\n/* 按钮组 */\n.DoubaoVideoNode-button-group {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n/* 视频比例按钮网格 - 4列布局 */\n.DoubaoVideoNode-aspect-ratio-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n}\n\n/* 视频比例按钮 - 字体稍小以适应较长的文本 */\n.DoubaoVideoNode-aspect-ratio-button {\n  font-size: 12px;\n  padding: 8px 6px;\n  white-space: nowrap;\n}\n\n/* 单个按钮 */\n.DoubaoVideoNode-button {\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  background-color: #ffffff;\n  color: #6b7280;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.DoubaoVideoNode-button:hover:not(:disabled) {\n  border-color: #8b5cf6;\n  color: #8b5cf6;\n  background-color: #f5f3ff;\n}\n\n.DoubaoVideoNode-button-active {\n  border-color: #8b5cf6;\n  background-color: #8b5cf6;\n  color: #ffffff;\n}\n\n.DoubaoVideoNode-button-active:hover:not(:disabled) {\n  background-color: #7c3aed;\n  border-color: #7c3aed;\n}\n\n.DoubaoVideoNode-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.DoubaoVideoNode-button-disabled {\n  background-color: #f3f4f6;\n  color: #d1d5db;\n  border-color: #e5e7eb;\n  cursor: not-allowed;\n}\n\n/* 小提示 */\n.DoubaoVideoNode-hint-small {\n  margin-top: 6px;\n  font-size: 11px;\n  color: #f59e0b;\n  line-height: 1.4;\n}\n\n/* 提示信息 */\n.DoubaoVideoNode-hint {\n  padding: 12px;\n  background-color: #fef3c7;\n  border: 1px solid #fbbf24;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 1.6;\n  color: #78350f;\n  margin-bottom: 16px;\n}\n\n/* 参考图片网格展示 */\n.DoubaoVideoNode-image-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.DoubaoVideoNode-image-thumb {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 2px solid #e5e7eb;\n  transition: all 0.2s;\n  background: #f9fafb;\n}\n\n.DoubaoVideoNode-image-thumb:hover {\n  border-color: #8b5cf6;\n  transform: scale(1.05);\n  z-index: 10;\n}\n\n.DoubaoVideoNode-image-inactive {\n  opacity: 0.4;\n  filter: grayscale(0.5);\n}\n\n.DoubaoVideoNode-image-dragging {\n  opacity: 0.5;\n  transform: scale(0.95);\n}\n\n.DoubaoVideoNode-thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.DoubaoVideoNode-thumb-index {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: rgba(139, 92, 246, 0.9);\n  color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.DoubaoVideoNode-thumb-role {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  background: rgba(16, 185, 129, 0.95);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n/* 图片占位符 */\n.DoubaoVideoNode-image-placeholder {\n  padding: 40px 20px;\n  text-align: center;\n  background-color: #f9fafb;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n/* 生成按钮 */\n.DoubaoVideoNode-generate {\n  width: 100%;\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);\n}\n\n.DoubaoVideoNode-generate:hover:not(:disabled) {\n  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);\n  transform: translateY(-1px);\n}\n\n.DoubaoVideoNode-generate:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.DoubaoVideoNode-generate-disabled {\n  background: #d1d5db;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* 错误提示 */\n.DoubaoVideoNode-error {\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #fee2e2;\n  border: 1px solid #ef4444;\n  border-radius: 8px;\n  color: #991b1b;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n/* 复制按钮样式 */\n.DoubaoVideoNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.DoubaoVideoNode-container:hover .DoubaoVideoNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.DoubaoVideoNode-duplicate-button:hover {\n  background: #f0f0f0;\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: scale(1.05);\n}\n\n.DoubaoVideoNode-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n.react-flow__node.selected .DoubaoVideoNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
